import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import React, { useContext, useEffect } from 'react';

import CanonicalURL from '@/components/common/Canonical';
import PopularLocations from '@/components/convenient-locations/popular-locations';
import HeroStoreSearchBanner from '@/components/hero-banner/hero-storesearch-banner';
import SafeStorageSolutions from '@/components/home-content/safe-storage-solutions';
import RightStore from '@/components/self-storage-residential/right-store';
import { getSEOProps } from '@/components/utility';
import FAQValet from '@/components/valet-service/faqValet';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import { getInnerPagesWithDefaultLocale } from '@/services/home';
import SetBrandsContext from '@/services/home/setBrands';
import {
  BRAND_NAME_EN,
  BRAND_NAME_FR,
  MOTOR_CYCLE,
  MOTOR_CYCLE_FR,
} from '@/utils/constants';

const TitleDescriptionComponent = dynamic(
  () => import('@/components/terms-conditions')
);
const ClientReviews = dynamic(
  () => import('@/components/home-content/client-reviews')
);

const MotorStore = (props: any) => {
  const headerFooterData = useContext(HeaderFooterContext);
  const { headerFooter } = headerFooterData;

  const { locale }: any = useRouter();

  const isContext = !!headerFooter[0];

  const getContextData = async () => {
    let defaultBrand = BRAND_NAME_EN;
    if (locale === 'fr') defaultBrand = BRAND_NAME_FR;
    const contextData = await SetBrandsContext(defaultBrand, locale);
    const brands = contextData?.data;
    headerFooterData.setHeaderFooterData(brands);
  };

  useEffect(() => {
    getContextData();
  }, [isContext, locale]);

  const teamTitle = props?.MotorStoreData?.attributes?.Section[4]?.Title;
  const teamData = props?.MotorStoreData?.attributes?.Section[5]?.Cards;
  const faqTitle = props?.MotorStoreData?.attributes?.Section[6]?.Title;

  const faqData = props?.MotorStoreData?.attributes?.Section[6]?.Panel;

  const carTitle = props?.MotorStoreData?.attributes?.Section[2]?.Title;
  const carData = props?.MotorStoreData?.attributes?.Section[3]?.Cards;

  const popularTitle = props?.MotorStoreData?.attributes?.Section[7]?.Title;
  const popularData = props?.MotorStoreData?.attributes?.Section[8]?.Cards;

  const stagingTitle = props?.MotorStoreData?.attributes?.Section[9]?.Title;
  const stagingDesc =
    props?.MotorStoreData?.attributes?.Section[9]?.Description;
  const stagingTitlee = props?.MotorStoreData?.attributes?.Section[10]?.Title;
  const stagingDescc =
    props?.MotorStoreData?.attributes?.Section[10]?.Description;
  const stagingTitleee = props?.MotorStoreData?.attributes?.Section[11]?.Title;
  const stagingDesccc =
    props?.MotorStoreData?.attributes?.Section[11]?.Description;
  const router = useRouter();
  const seoProps = getSEOProps(props?.MotorStoreData?.attributes?.SEO, router);
  const { hostUrl } = props;
  return (
    <>
      <NextSeo {...seoProps} />
      <CanonicalURL />
      <HeroStoreSearchBanner
        isBread={true}
        cmsData={props?.MotorStoreData}
        hostUrl={hostUrl}
      />
      <SafeStorageSolutions
        title={carTitle}
        cards={carData}
        hostUrl={hostUrl}
      />
      <RightStore teamTitle={teamTitle} teamData={teamData} hostUrl={hostUrl} />
      <FAQValet data={faqData} title={faqTitle} hostUrl={hostUrl} />
      <ClientReviews />
      <PopularLocations
        title={popularTitle}
        popularLocationsData={popularData}
        hostUrl={hostUrl}
      />
      <TitleDescriptionComponent
        isBread={false}
        title={stagingTitle}
        description={stagingDesc}
        hostUrl={hostUrl}
      />
      <TitleDescriptionComponent
        isBread={false}
        title={stagingTitlee}
        description={stagingDescc}
        hostUrl={hostUrl}
      />
      <TitleDescriptionComponent
        isBread={false}
        title={stagingTitleee}
        description={stagingDesccc}
        hostUrl={hostUrl}
      />
    </>
  );
};

export async function getServerSideProps(props: any) {
  const locale = props?.locale;
  let defaultBrand = BRAND_NAME_EN;
  let defaultLink = MOTOR_CYCLE;
  const host = props?.req?.headers?.host;
  const hostUrl = `${host}/${locale}`;
  if (locale === 'fr') {
    defaultLink = MOTOR_CYCLE_FR;
    defaultBrand = BRAND_NAME_FR;
  }

  const stagingRes = await getInnerPagesWithDefaultLocale(
    defaultLink,
    defaultBrand,
    locale
  );

  const MotorStoreData = (await stagingRes?.data?.data[0]) || null;

  return {
    props: {
      MotorStoreData,
      hostUrl,
    },
  };
}

export default MotorStore;
